import { compose, setDisplayName, withProps } from 'recompose';

import {
  KEY_TEXT_QUESTION_FONT_COLOR,
  KEY_TEXT_QUESTION_FONT_FAMILY,
  KEY_TEXT_QUESTION_FONT_SIZE,
  KEY_TEXT_QUESTION_FONT_STYLE,
  KEY_TEXT_QUESTION_FONT_WEIGHT,
  KEY_TEXT_QUESTION_TEXT_DECORATION,
} from '../../const/keysBlockStyling';

import {
  isFontBold,
  isFontItalic,
  isTextUnderlined,
} from '../../../richText/utils/inlineStyleChecks';

const StylingTextQuestionToRTEProps = withProps(
  ({
    styling: {
      [KEY_TEXT_QUESTION_FONT_COLOR]: defaultFontColor,
      [KEY_TEXT_QUESTION_FONT_FAMILY]: defaultFont,
      [KEY_TEXT_QUESTION_FONT_SIZE]: defaultFontSize,
      [KEY_TEXT_QUESTION_FONT_STYLE]: fontStyle,
      [KEY_TEXT_QUESTION_FONT_WEIGHT]: fontWeight,
      [KEY_TEXT_QUESTION_TEXT_DECORATION]: textDecoration,
    } = {},
  }) => ({
    defaultFont,
    defaultFontColor,
    defaultFontSize,
    defaultBold: isFontBold(fontWeight),
    defaultItalic: isFontItalic(fontStyle),
    defaultUnderline: isTextUnderlined(textDecoration),
  }),
);

export default compose(
  setDisplayName('StylingTextQuestionToRTEProps'),
  StylingTextQuestionToRTEProps,
);
